export const ATTACHMENT_TYPE_LINK = 'link';
export const ATTACHMENT_TYPE_UPLOAD = 'upload';

export const ALL_ATTACHMENT_TYPES = [
  ATTACHMENT_TYPE_LINK,
  ATTACHMENT_TYPE_UPLOAD,
];

export const MAX_ATTACHMENTS_PER_VIDEO = 6;
